/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-pause': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 5v10H5V5h2.5zm0-1.25H5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM15 5v10h-2.5V5H15zm0-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25H15c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
